<img src="../../../../../assets/images/SPACE AR small.png" style="width:100px;margin-left:20px;"/>
<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
    <div>
      <div class="row">
        <div class="col-12">
            <span style="font-size:16px;">
           {{primaryVerbiage}}
           </span>
        </div>
      </div>
    </div>
   
<div mat-dialog-actions style="margin-top:50px;">
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial >OK</button>
</div>

